export default "__VITE_ASSET__CChVm$1x__"